import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionAr = () => {
  return (
    <section className="app-section rtl">
      <h1>كيفية تحميل تطبيق Tango: دليل خطوة بخطوة</h1>
      <h5>انطلق مباشرةً. تواصل. استمتع – في أي وقت، في أي مكان!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>بقلم: Violetta</span>
          <span>تم إجراء التحديث اليوم</span>
        </div>
      </div>
      <p>
        <b>
          Tango متاح على منصات متعددة، مما يسهل عليك البث المباشر والاستمتاع بالترفيه المباشر في أي وقت ومن أي مكان.
        </b>
      </p>
      <hr />
      <h2>🤖 لمستخدمي أجهزة أندرويد</h2>
      <p>
        يمكنك تنزيل التطبيق مباشرة من:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <br />
      <h2> لأجهزة iOS:</h2>
      <p>
        <b>
          إذا قمت بتثبيت التطبيق مسبقًا على جهاز iOS الخاص بك، يمكنك إعادة تنزيله من متجر App Store.
        </b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        1. افتح متجر App Store: قم بالدخول إلى متجر التطبيقات على جهاز iOS الخاص بك.
      </p>
      <p>
        2. اضغط على صورة ملفك الشخصي: في الزاوية العلوية اليمنى من الشاشة للوصول إلى إعدادات الحساب.
      </p>
      <p>
        3. انتقل إلى "التطبيقات" أو "سجل المشتريات": تصفح قائمة التطبيقات التي قمت بشرائها مسبقًا أو استخدم شريط البحث في الأعلى للبحث عن "Tango".
      </p>
      <p>
        4. أعد تنزيل التطبيق: بمجرد العثور على Tango في القائمة، اضغط على رمز السحابة مع السهم لإعادة تنزيل التطبيق.
      </p>
      <p>
        5. افتح تطبيق Tango بعد التثبيت: واتبع عملية التسجيل أو تسجيل الدخول.
      </p>
      <hr />
      <h2>جديد في Tango؟ أضف Tango بسهولة إلى الشاشة الرئيسية لهاتفك للوصول السريع</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        1. افتح موقع Tango: افتح الرابط <a href="https://tngrenkli.me/">https://tngrenkli.me/</a> في متصفح هاتفك المحمول.
      </p>
      <p>
        2. اضغط على أيقونة المشاركة: وهي المربع الذي يحتوي على سهم متجه للأعلى في أسفل الشاشة.
      </p>
      <p>
        3. اختر "إضافة إلى الشاشة الرئيسية": من القائمة وستتم إضافة اختصار Tango إلى الشاشة الرئيسية لجهازك.
      </p>
      <p>بمجرد تثبيت التطبيق، ستكون جاهزًا للانطلاق مباشرة، دعم المبدعين المفضلين لديك، والاستمتاع بترفيه لا نهائي – كل ذلك في متناول يدك!</p>
      <br/>
      <b>ابدأ الآن وانضم إلى المغامرة! 🎉</b>
    </section>
  );
};

export default SectionAr;




// import React from "react";
// import YouTube from "react-youtube";
// import Logo from "./Logo";
// import "./Section.css";
// import {APKLink, GoogleStoreLink, HuaweiLink, XiaomiLink} from "./Links";
//
// const SectionAr = () => {
//   return (
//     <section className="app-section rtl">
//       <h1>كيفية تحميل تطبيق Tango: دليل خطوة بخطوة</h1>
//       <h5>أعد تحميل تطبيق Tango على هاتفك باستخدام هذا الدليل📲</h5>
//       <div className="icon-section">
//         <Logo />
//         <div className="icon-section__text">
//           <span>بقلم: Violetta</span>
//           <span>تم إجراء التحديث اليوم</span>
//         </div>
//       </div>
//       <p>
//         <b>
//           تحديث Tango (13 ديسمبر، الساعة 2:00 مساءً بالتوقيت العالمي)، Tango عاد إلى Google Play!<br />
//           <GoogleStoreLink text={"قم بتنزيله هنا"} />
//         </b>
//       </p>
//       <p>
//         Tango غير متاح مؤقتًا للتنزيل من متجر App Store ومتجر Google Play الخبر
//         الرائع هو أن كل شيء داخل التطبيق يعمل بسلاسة! ✨
//       </p>
//       <p>
//         نوصي بشدة بعدم إلغاء تثبيت التطبيق في الوقت الحالي لتتمكن من الاستمرار
//         في الاستمتاع بـ Tango باستخدام النسخة الحالية من التطبيق.
//       </p>
//       <h3>إليك كيفية إعادة تنزيل تطبيق Tango على جهازك</h3>
//
//       <h2>لأجهزة iOS:</h2>
//       <p>
//         إذا كنت قد قمت سابقًا بتثبيت تطبيق Tango على جهاز iOS الخاص بك ثم ألغيت
//         تثبيته، يمكنك إعادة تنزيله من App Store.
//       </p>
//       <YouTube videoId="fFAt5BAR-bk" />
//       <p>1. افتح App Store: ادخل إلى متجر التطبيقات على جهاز iOS الخاص بك.</p>
//       <p>
//         2. اضغط على صورة ملفك الشخصي في الزاوية العلوية اليمنى من الشاشة لفتح
//         إعدادات الحساب.
//       </p>
//       <p>
//         3. انتقل إلى 'التطبيقات' أو 'سجل الشراء': تصفح قائمة التطبيقات التي
//         اشتريتها سابقًا أو استخدم شريط البحث في الأعلى لكتابة “Tango”.
//       </p>
//       <p>
//         4. أعد تنزيل تطبيق Tango: بمجرد العثور على Tango في القائمة، اضغط على
//         رمز السحابة مع السهم بجانبه لإعادة تنزيل التطبيق.
//       </p>
//       <p>
//         5. افتح تطبيق Tango بعد التثبيت واتبع عملية التسجيل أو تسجيل الدخول.
//       </p>
//       <hr />
//       <h2>لأجهزة Android:</h2>
//       <p>
//         1. شاهد الفيديو التعليمي أدناه لتتعلم كيفية تثبيت التطبيق يدويًا
//         باستخدام رابط تنزيل مباشر 👇
//       </p>
//       <YouTube videoId="eetLELJviDs" />
//       <p>
//         2. افتح رابط APK لنظام Android في متصفح هاتفك المحمول --> <APKLink />
//       </p>
//       <p>
//         قم بتنزيل التطبيق: سيتم توجيهك إلى صفحة تنزيل Tango الرسمية. اضغط على زر
//         التنزيل لبدء تنزيل ملف APK (ملف تثبيت Android). *إذا لم تقم بتمكين تثبيت
//         التطبيقات من مصادر غير معروفة بعد، قد تحتاج إلى تفعيل هذا الإعداد في
//         جهازك.
//       </p>
//       <p>
//         <b>كيفية تمكين تثبيت التطبيقات من مصادر غير معروفة:</b>
//       </p>
//       <ul>
//         <li>
//           انتقل إلى الإعدادات > الأمان > تثبيت التطبيقات من مصادر غير معروفة.
//         </li>
//         <li>
//           ابحث عن متصفحك (Chrome، Safari، إلخ)، وقم بتمكين الخيار للسماح لجهازك
//           بتثبيت التطبيقات من مصادر غير معروفة.
//         </li>
//       </ul>
//       <p>
//         4. قم بتثبيت التطبيق: بمجرد تنزيل ملف APK، اضغط على الإشعار لبدء
//         التثبيت. اتبع التعليمات لإكمال عملية التثبيت.
//       </p>
//       <p>
//         5. افتح تطبيق Tango بعد التثبيت واتبع عملية التسجيل أو تسجيل الدخول.
//       </p>
//       <hr />
//       <h2>أضف Tango بسهولة إلى الشاشة الرئيسية للوصول السريع</h2>
//       <h3>لأجهزة iOS:</h3>
//       <YouTube videoId="Axu8teuVQNQ" />
//       <p>
//         1. افتح موقع Tango الإلكتروني: افتح الرابط https://tngrenkli.me في متصفح
//         هاتفك المحمول
//       </p>
//       <p>2. اضغط على أيقونة المشاركة: المربع مع السهم للأعلى في أسفل الشاشة</p>
//       <p>
//         3. اختر "إضافة إلى الشاشة الرئيسية" من القائمة وسيتم إضافة اختصار Tango
//         إلى الشاشة الرئيسية لجهازك
//       </p>
//       <h3>لأجهزة Android:</h3>
//       <YouTube videoId="Y3Owabj4Y4A" />
//       <p>
//         1. افتح موقع Tango الإلكتروني: افتح الرابط https://tngrenkli.me في متصفح
//         هاتفك المحمول
//       </p>
//       <p>2. اضغط على أيقونة القائمة: في الزاوية العلوية اليمنى من متصفحك</p>
//       <p>
//         3. اختر "إضافة إلى الشاشة الرئيسية" من القائمة وسيتم إضافة اختصار Tango
//         إلى الشاشة الرئيسية لجهازك
//       </p>
//       <p>
//         Tango متاح أيضًا للتنزيل على <XiaomiLink /> و <HuaweiLink />.
//       </p>
//       <p>شكرًا لصبرك ودعمك المستمر!</p>
//     </section>
//   );
// };
//
// export default SectionAr;
